module.exports = __webpack_public_path__ + "static/veritable-large-ebc901e978766c175134f04113845ca5.jpg";